import { useEffect } from 'react'
import { useAuthStore } from '../../stores/authStore'
import { useBackgroundJobsStore } from '../../stores/backgroundJobsStore'
import { useNotificationsStore } from '../../stores/notificationsStore'

/**
 * Manages the WebSocket connections for background jobs and notifications.
 * Mount once inside the authenticated layout.
 */
export function WebSocketProvider({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const token = useAuthStore((s) => s.token)
  const connectJobs = useBackgroundJobsStore((s) => s.connect)
  const jobsConnected = useBackgroundJobsStore((s) => s.isConnected)
  const connectNotifications = useNotificationsStore((s) => s.connect)
  const disconnectNotifications = useNotificationsStore((s) => s.disconnect)

  useEffect(() => {
    if (isAuthenticated && token) connectNotifications(token)
    else disconnectNotifications()
    return () => disconnectNotifications()
  }, [isAuthenticated, token, connectNotifications, disconnectNotifications])

  useEffect(() => {
    if (isAuthenticated && token && !jobsConnected) {
      connectJobs(token)
    }
  }, [isAuthenticated, token, jobsConnected, connectJobs])

  return <>{children}</>
}
